import { useEffect, useState } from 'react';
import { Navigate, Route, Routes, useLocation, useNavigate } from 'react-router-dom';
import { BottomNav } from './components/BottomNav';
import { Loading } from './components/Loading';
import Dashboard from './pages/Dashboard';
import Offers from './pages/Offers';
import ImportOffer from './pages/ImportOffer';
import OfferDetail from './pages/OfferDetail';
import MapPage from './pages/MapPage';
import MorePage from './pages/MorePage';
import Onboarding from './pages/Onboarding';
import ProjectsPage from './pages/ProjectsPage';
import CreateProjectPage from './pages/CreateProjectPage';
import { QuickAdd } from './components/QuickAdd';
import { activeProjectId, api, selectProject } from './api';
import type { ProjectsData } from './types';

export default function App() {
  const location = useLocation(); const navigate = useNavigate();
  const [quickAdd, setQuickAdd] = useState(false);
  const [projectsReady, setProjectsReady] = useState(false);
  useEffect(() => {
    let cancelled = false;
    api<ProjectsData>('/api/projects').then(projects => {
      if (cancelled) return;
      const selected = activeProjectId();
      const validSelection = projects.active.some(project => project.id === selected);
      if (!validSelection) selectProject(projects.active[0]?.id || null);
      if (!projects.active.length && location.pathname !== '/projekty/nowy') navigate('/projekty/nowy', { replace: true });
      setProjectsReady(true);
    }).catch(() => setProjectsReady(true));
    return () => { cancelled = true; };
  }, []);
  const noNav = location.pathname === '/welcome' || location.pathname === '/projekty/nowy';
  if (!projectsReady) return <div className="app-shell"><main className="app-main no-nav"><Loading /></main></div>;
  return <div className="app-shell">
    <main className={noNav ? 'app-main no-nav' : 'app-main'}>
      <Routes>
        <Route path="/" element={<Dashboard />} />
        <Route path="/welcome" element={<Onboarding />} />
        <Route path="/oferty" element={<Offers />} />
        <Route path="/archiwum" element={<Offers archived />} />
        <Route path="/oferty/:id" element={<OfferDetail />} />
        <Route path="/dodaj" element={<ImportOffer />} />
        <Route path="/mapa" element={<MapPage />} />
        <Route path="/wiecej" element={<MorePage />} />
        <Route path="/projekty" element={<ProjectsPage />} />
        <Route path="/projekty/nowy" element={<CreateProjectPage />} />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </main>
    {!noNav && <BottomNav onAdd={() => setQuickAdd(true)} />}
    <QuickAdd open={quickAdd} onClose={() => setQuickAdd(false)} />
  </div>;
}
